import client from '../client'

/**
 * Fetches core data
 * @param {string} brandId ID of the brand you're fetching
 */
export const getCoreDataByBrand = (brandId) =>
  client.get(`dashboard/v1/brands/${brandId}/core`)
